/* DIGGO page-aligned book reader. The PDF Flipbook iframe remains available as an alternative in the section editor. */
(function () {
  'use strict';
  if (window.__diggoBookReaderReady) return;
  window.__diggoBookReaderReady = true;

  function initReader(reader) {
    if (reader.dataset.readerInitialized === 'true') return;
    const sources = Array.from(reader.querySelectorAll('[data-reader-page]')).map(function (el) {
      return { src: el.dataset.imageUrl, alt: el.dataset.imageAlt };
    }).filter(function (page) { return Boolean(page.src); });
    const stage = reader.querySelector('[data-reader-stage]');
    const previous = reader.querySelector('[data-reader-prev]');
    const next = reader.querySelector('[data-reader-next]');
    const status = reader.querySelector('[data-reader-status]');
    if (!sources.length || !stage || !previous || !next || !status) return;
    reader.dataset.readerInitialized = 'true';
    let spreads = [];
    let index = 0;
    let currentMode = '';
    let locked = false;

    function isSingleMode() {
      return window.matchMedia('(max-width: 700px)').matches || reader.dataset.desktopLayout === 'single';
    }

    function makeSpreads() {
      const groups = [];
      const total = sources.length;
      if (isSingleMode()) {
        for (let i = 0; i < total; i += 1) groups.push([i]);
      } else {
        let i = 0;
        if (reader.dataset.singleCover === 'true') {
          groups.push([0]);
          i = 1;
        }
        while (i < total) {
          if (i === total - 1 || (reader.dataset.singleBack === 'true' && i === total - 1)) {
            groups.push([i]);
            i += 1;
          } else {
            groups.push([i, i + 1]);
            i += 2;
          }
        }
      }
      return groups;
    }

    function makeImage(page, pageIndex) {
      const wrapper = document.createElement('div');
      wrapper.className = 'dg-book-reader__page';
      const img = document.createElement('img');
      img.src = page.src;
      img.alt = page.alt || ('Book page ' + (pageIndex + 1));
      img.loading = pageIndex < 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 913;
      img.height = 1255;
      wrapper.appendChild(img);
      return wrapper;
    }

    function render(direction) {
      const group = spreads[index] || [];
      const spread = document.createElement('div');
      spread.className = 'dg-book-reader__spread ' + (group.length === 1 ? 'dg-book-reader__spread--single' : 'dg-book-reader__spread--double');
      if (reader.dataset.animation === 'turn' && direction) {
        spread.classList.add(direction === 'next' ? 'dg-book-reader__flip-next' : 'dg-book-reader__flip-prev');
      }
      group.forEach(function (pageIndex) {
        spread.appendChild(makeImage(sources[pageIndex], pageIndex));
      });
      stage.replaceChildren(spread);
      previous.disabled = index === 0;
      next.disabled = index >= spreads.length - 1;
      if (group.length === 1 && group[0] === 0 && reader.dataset.singleCover === 'true') {
        status.textContent = 'Front cover · Page 1 of ' + sources.length;
      } else if (group.length === 1 && group[0] === sources.length - 1 && reader.dataset.singleBack === 'true') {
        status.textContent = 'Back cover · Page ' + sources.length + ' of ' + sources.length;
      } else if (group.length === 1) {
        status.textContent = 'Page ' + (group[0] + 1) + ' of ' + sources.length;
      } else {
        status.textContent = 'Pages ' + (group[0] + 1) + '–' + (group[1] + 1) + ' of ' + sources.length;
      }
    }

    function regroup() {
      const mode = isSingleMode() ? 'single' : 'spread';
      if (currentMode === mode) return;
      let page = 0;
      if (spreads[index] && spreads[index].length) page = spreads[index][0];
      currentMode = mode;
      spreads = makeSpreads();
      const containing = spreads.findIndex(function (group) { return group.includes(page); });
      index = containing < 0 ? 0 : containing;
      render();
    }

    previous.addEventListener('click', function () {
      if (index > 0 && !locked) { index -= 1; render('prev'); }
    });
    next.addEventListener('click', function () {
      if (index < spreads.length - 1 && !locked) { index += 1; render('next'); }
    });
    reader.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' && !next.disabled) {
        event.preventDefault(); next.click();
      } else if (event.key === 'ArrowLeft' && !previous.disabled) {
        event.preventDefault(); previous.click();
      } else if (event.key === 'Home') {
        event.preventDefault(); index = 0; render();
      } else if (event.key === 'End') {
        event.preventDefault(); index = spreads.length - 1; render();
      }
    });
    window.addEventListener('resize', regroup, { passive: true });
    regroup();
  }

  function boot(parent) {
    const context = parent && parent.querySelectorAll ? parent : document;
    context.querySelectorAll('[data-diggo-book-reader]').forEach(initReader);
    if (context.matches && context.matches('[data-diggo-book-reader]')) initReader(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();